export default {
  400: 'The issued request is malformed or illegal',
  404: 'The requested resource has been removed, had its name changed or is temporarily unavailable'
}
